import mixpanel from "../services/mixpanelService";

export const saveImage = (imgRef: any) => {
  mixpanel.track("image-copied");
  const canvas = imgRef?.current?.querySelector("canvas");
  if (canvas) {
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qr-code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
};

export const sendSMS = (shareUrl: string, charityName: string, isAmazon = false) => {
  mixpanel.track("sms-button-clicked", {
    charityName,
    shareUrl
  });

  if (isAmazon) {
    const amazonCampaignMessage = `I just planted and protected a tree in the Amazon with the Global Citizen community. It’s real and takes one minute. Tap the link and play to plant your tree now. ${shareUrl}`;
    window.location.href = `sms:?&body=${encodeURIComponent(amazonCampaignMessage)}`;
  } else {
    const defaultMessage =
      `Help me support ${charityName}. ` +
      `This link raises money for the charity when you PLAY and share! ` +
      `There's no cost involved :) ${shareUrl}`;
    window.location.href = `sms:?&body=${encodeURIComponent(defaultMessage)}`;
  }
};
